export const SPACING = {
  0: 0,
  4: 4,
  8: 8,
  16: 16,
  24: 24,
  40: 40,
  64: 64,
  104: 104,
  168: 168,
  272: 272,
  440: 440,
} as const
